/*

Field validation for formidable forms

 */

VMasker(document.querySelectorAll(".number-format-field input")).maskMoney({
	precision: 0,
	separator: '.',
	delimiter: ',',
});

VMasker(document.querySelectorAll(".phone-format-field input")).maskPattern("(999) 999-9999");
